<div class="form-control-container">
  <label>{{label}}</label>
  <ng-content></ng-content>
</div>
